import React from 'react';
import { useLocation } from 'react-router-dom';
import { history } from '../../_helpers';

const Activate = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const customerId = params.get('customer');
  const token = params.get('auth');
  const nopass = params.get('nopass');

  if (customerId && token) {
    history.push(
      `/login/activate?customer=${customerId}&auth=${token}&nopass=${nopass}`
    );
  }

  return <React.Fragment></React.Fragment>;
};

export { Activate };
